'use client';

import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';

import { useCurrentUser } from '~/app/hooks';
import { useTrack } from '~/hooks/event';

interface Props {
  page: string;
  properties?: Record<string, unknown>;
  condition?: boolean;
}

export function TrackPage({ page, properties, condition }: Props) {
  const { track } = useTrack();
  const { user } = useCurrentUser();
  const searchParams = useSearchParams();

  const query = useMemo(() => {
    if (!searchParams) return {};

    const params: Record<string, string | string[]> = {};
    searchParams.forEach((value, key) => {
      const existing = params[key];
      if (existing) {
        params[key] = Array.isArray(existing)
          ? [...existing, value]
          : [existing, value];
      } else {
        params[key] = value;
      }
    });
    return params;
  }, [searchParams]);

  useEffect(() => {
    if (!user || condition) return;
    track(`viewed ${page} page`, {
      ...properties,
      ...query,
      query,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return null;
}
